const LEGAL_FORM_MAP: Record<string, string> = {
  GeneralPartnership: 'Spółka jawna',
  LimitedLiabilityCompany: 'Spółka z o.o.',
  JointStockCompany: 'Spółka akcyjna',
  LimitedPartnership: 'Spółka komandytowa',
  LimitedJointStockPartnership: 'Spółka komandytowo-akcyjna',
  ProfessionalPartnership: 'Spółka partnerska',
  CivilLawPartnership: 'Spółka cywilna',
};

const PROPERTY_RIGHTS_SLUG_MAP: Record<string, string> = {
  PROPERTY_RIGHTS_GENERAL_PARTNERSHIP_INFO: 'Wspólnik spółki jawnej',
  PROPERTY_RIGHTS_JOIN_STOCK_COMAPNY_INFO: 'Akcjonariusz',
  PROPERTY_RIGHTS_JOINT_STOCK_LIMITED_PARTNERSHIP_INFO: 'Akcjonariusz S.K.A.',
  PROPERTY_RIGHTS_PROFESSIONAL_PARTNERSHIP_INFO: 'Partner spółki partnerskiej',
  PROPERTY_RIGHTS_EUROPEAN_ECONOMIC_INTEREST_GROUPING_INFO: 'Członek EZIG',
};

export function mapLegalFormValue(legalForm: string): string {
  return LEGAL_FORM_MAP[legalForm] ?? legalForm ?? '—';
}

export function mapDebtRecordValue(hasDebtRecord: unknown): string {
  if (hasDebtRecord === true || hasDebtRecord === 'YES') {
    return 'TAK';
  }

  if (hasDebtRecord === false || hasDebtRecord === 'NO') {
    return 'NIE';
  }

  return 'BRAK DANYCH';
}

export function mapPropertyRightsTextValue(item: {
  propertyRightsInfo?: { isSlug?: boolean; text?: unknown } | null;
}): string {
  const info = item?.propertyRightsInfo;
  if (!info) {
    return '—';
  }

  if (info.isSlug) {
    const key = info.text != null ? String(info.text) : '';
    return PROPERTY_RIGHTS_SLUG_MAP[key] ?? (key || '—');
  }

  return info.text != null ? String(info.text) : '—';
}
